"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var icons_1 = require("@material-ui/icons");
var classnames_1 = require("classnames");
var React = require("react");
var player_1 = require("./state/player");
exports.useComponentStyles = core_1.makeStyles({
    icon: function (props) { return ({
        color: props.playerColors.active,
        '&:hover': {
            color: props.playerColors.hover
        }
    }); }
});
var AudioPlayControl = function (_a) {
    var playerStatus = _a.playerStatus, playerColors = _a.playerColors, pauseAudio = _a.pauseAudio, playAudio = _a.playAudio, replayAudio = _a.replayAudio, _b = _a.classNames, classNames = _b === void 0 ? {} : _b;
    var classes = exports.useComponentStyles({ playerColors: playerColors });
    switch (playerStatus) {
        case player_1.default.STATUS.PLAY:
            return (React.createElement(icons_1.PauseCircleFilled, { fontSize: "large", onClick: pauseAudio, className: classnames_1.default(classes.icon, classNames.pauseIcon) }));
        case player_1.default.STATUS.STOP:
            return (React.createElement(icons_1.Replay, { fontSize: "large", onClick: replayAudio, className: classnames_1.default(classes.icon, classNames.replayIcon) }));
        default:
            return (React.createElement(icons_1.PlayCircleFilledWhite, { fontSize: "large", onClick: playAudio, className: classnames_1.default(classes.icon, classNames.playIcon) }));
    }
};
exports.default = React.memo(AudioPlayControl);
//# sourceMappingURL=AudioPlayControl.js.map